export const Venues = () => (
  <section data-testid="venues-section" className="py-20 bg-sand border-t border-cream px-6 md:px-12">
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
      <div className="md:col-span-6">
        <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-forest font-semibold">
          London Studios
        </span>
        <h2 className="font-display text-3xl md:text-4xl text-ink mt-2 mb-6">
          Dedicated training spaces across South London.
        </h2>
        <div className="space-y-4 text-sm text-sage">
          <div data-testid="venue-card-1" className="p-4 bg-linen rounded-xl border border-cream">
            <strong className="text-ink block">Rosendale Road Studio (Mon–Tue)</strong>
            <span>Flat 2 Block G, Rosendale Road, Herne Hill, London SE24 9ED</span>
          </div>
          <div data-testid="venue-card-2" className="p-4 bg-linen rounded-xl border border-cream">
            <strong className="text-ink block">Mr Salus Sporting Lab (Wed–Fri)</strong>
            <span>Studio 7, 360a Coldharbour Lane, Brixton, London SW9 8PL</span>
          </div>
        </div>
      </div>
      <div className="md:col-span-6">
        <div className="rounded-2xl overflow-hidden aspect-[4/3] border border-cream shadow-md relative">
          <img
            data-testid="venue-image"
            src="https://images.pexels.com/photos/6560308/pexels-photo-6560308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Professional clinical treatment room"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end p-6 bg-gradient-to-t from-black/60 to-transparent h-full">
            <p className="text-white text-xs font-monolbl uppercase tracking-wider">
              Professional clinical setting for maximum hands-on focus
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
